/* «Профиль». Оболочка — экран React: колонка #profile.
   Содержимое колонки и листы отдаёт prepare() один раз. Дальше раздел сам меняет узлы, и React этот кадр не перерисовывает.
   Листы стоят рядом со страницей: внутри .stp-in они уехали бы вместе с прокруткой. */
import { useLayoutEffect, useState } from 'react';
import { LegacyHtml } from '../../ui/LegacyHtml';
import { profileApi } from './module';

export function Profile() {
  const api = profileApi();
  const [m] = useState(() => api.prepare());
  useLayoutEffect(() => {
    api.attach();
  }, [api]);
  return (
    <>
      <div className="pg stp" id="profile">
        <div className="stp-in" dangerouslySetInnerHTML={{ __html: m.body }} />
      </div>
      <LegacyHtml html={() => m.sheets} />
    </>
  );
}
